import { render, staticRenderFns } from "./DlgDownloadCategory.vue?vue&type=template&id=70c7bed5&scoped=true&"
import script from "./DlgDownloadCategory.vue?vue&type=script&lang=js&"
export * from "./DlgDownloadCategory.vue?vue&type=script&lang=js&"
import style0 from "./DlgDownloadCategory.vue?vue&type=style&index=0&id=70c7bed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7bed5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSimpleTable,VSpacer,VTextField,VToolbar,VToolbarTitle})
